import { Injectable } from '@angular/core';
import {ModalWindowParameters} from './modal-window-parameters';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ModalWindowResponse} from './modal-window-response';

@Injectable({
  providedIn: 'root'
})
export class ModalWindowService {
  modalWindowParameters: BehaviorSubject<ModalWindowParameters> = new BehaviorSubject<ModalWindowParameters>(null);
  modalWindowResponse: Subject<ModalWindowResponse> = new Subject<ModalWindowResponse>();
  constructor() { }

  onResponse(response: ModalWindowResponse) {
    this.modalWindowResponse.next(response);
    this.modalWindowParameters.next(null);
  }
  showWindow(parameters: ModalWindowParameters): Observable<ModalWindowResponse> {
    this.modalWindowParameters.next(parameters);
    return this.modalWindowResponse;
  }
}
